<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-title>{{ t('UserProfilePage.likedItems') }}</ion-title>
        <ion-buttons slot="start">
          <ion-back-button default-href="/profile"></ion-back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <!-- Loading Data -->
      <div class="spin" v-if="loading">
        <ion-spinner></ion-spinner>
      </div>
      <ion-grid fixed>
        <ion-row>
          <ion-col size-xs="6" size-md="4" size-xl="3" v-for="product in products" :key="product.id">
            <product-card :product="product" :extraRouterParams="{ parentPath: '/liked-products' }"></product-card>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
// Vue reactivity
import { computed, ref } from "vue";

// components
import { IonHeader, IonToolbar, IonTitle, IonContent, IonPage,
        IonGrid, IonRow, IonCol, IonSpinner, IonButtons, IonBackButton } from "@ionic/vue";
import ProductCard from "@/components/ProductCard.vue";

import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

export default {
  name: "UserLikedItemListPage",
  components: {
    IonHeader, IonToolbar, IonTitle, IonContent, IonPage,
    IonGrid, IonRow, IonCol, IonSpinner, IonButtons, IonBackButton, ProductCard,
  },
  setup() {
    const store = useStore();
    // 1. declare state variables (ref to make them reactive)
    const loading = ref(false);
    const products = computed(() => store.getters.userLikedItems);

    // methods or filters
    const { t } = useI18n();

    // 3. return variables & methods to be used in template HTML
    return {
      t,

      // state variables
      loading, products,
    };
  },
};
</script>

<style scoped>
</style>